const setStatusList = (state, data) => {
  state.statusList = data;
};

export default {
  setStatusList
};
